import { db } from 'firebase/fbConfig.js';

// Get Users for Users Panel
export function listenToNotificationsForUser(store, uid, userEmail) {
  console.log('userEmail!!!!!!', userEmail)
  return db
    .collection('users')
    .doc(uid)
    .collection('notifications')
    .where('status', '==', 'new')
    .where('from.email', '!=', userEmail)
    .orderBy('from.email', 'desc')
    .onSnapshot((snapshot) => {
      console.log('snapshot', snapshot)
      snapshot.docChanges().forEach((change) => {
        var data = change.doc.data()
        const id = change.doc.id;
        switch (change.type) {
          case 'added':
            store.dispatch(addNotification(id, data));
            break;
          case 'modified':
            store.dispatch(modifyNotification(id, data));
            break;
          case 'removed':
            store.dispatch(removeNotification(id));
            break;
        }
      });
    });
}

export function startCreateNotification(uid, notification) {
  console.log('startCreateNotification', uid, notification);
  return (dispatch) => {
    notification = { createdAt: new Date(), ...notification };
    return db
      .collection('users')
      .doc(uid)
      .collection('notifications')
      .add(notification)
      .then((doc) => {
        console.log('startCreateNotification', doc.id);
        return doc.id;
      });
  };
}

export function startModifyNotification(uid, nid, notification) {
  return (dispatch) => {
    return db
      .collection('users')
      .doc(uid)
      .collection('notifications')
      .doc(nid)
      .update(notification);
  };
}

export function addNotification(nid, data) {
  return {
    type: 'NOTIFICATIONS_ADD',
    data,
    nid,
  };
}

export function modifyNotification(nid, data) {
  return {
    type: 'NOTIFICATIONS_MODIFY',
    data,
    nid,
  };
}

export function removeNotification(nid, cid) {
  return {
    type: 'NOTIFICATIONS_REMOVE',
    nid,
    cid
  };
}
